import React from 'react';
import { TEACHER_PLANS } from '../../config/teacherPlans';

const TeacherPlanNotice: React.FC = () => (
  <div
    style={{
      width: '100%',
      maxWidth: '720px',
      margin: '24px auto',
      padding: '28px 24px',
      borderRadius: '16px',
      background: 'var(--Color-background-normal, white)',
      border: '1px solid var(--Color-line-normal, #F0F0F0)',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      fontFamily: 'var(--font-family-primary)',
    }}
  >
    <div style={{ fontSize: '22px', fontWeight: 600, color: 'var(--Color-text-strong, #0D0D0D)' }}>
      이 기능은 상위 요금제에서 사용할 수 있습니다
    </div>
    <div style={{ fontSize: '15px', lineHeight: '22px', color: 'var(--Color-text-normal, #161616)' }}>
      담당 교사의 요금제에 따라 학급에서 열리는 기능이 달라집니다. 요금제 변경은 최고 관리자에게 요청해 주세요.
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {TEACHER_PLANS.map((plan) => (
        <div key={plan.id} style={{ fontSize: '14px', lineHeight: '21px', color: 'var(--Color-text-strong, #0D0D0D)' }}>
          <strong>{plan.name}</strong> · {plan.summary}
        </div>
      ))}
    </div>
  </div>
);

export default TeacherPlanNotice;
